import React, { useState } from 'react';
import styles from './ResponsiveHeader.module.scss';
import logo from '../../asserst/logo/Logo.svg';
import { Grid, List, ListItemButton, ListItemText, useMediaQuery } from '@mui/material';
import { IoReorderThreeSharp } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

const ReorderThreeSharpIcon = IoReorderThreeSharp as React.FC<React.SVGProps<SVGSVGElement>>;

const ResponsiveHeader: React.FC = () => {
    const navigation = useNavigate();
    const [show, setShow] = useState(false);


    const isTabletOrMobile = useMediaQuery('(max-width:1024px)');

    const data = [
        { label: 'HOME', path: '/' },
        { label: 'ABOUT', path: '/about' },
        { label: 'SERVICES', path: '/service' },
        { label: 'PORTFOLIO', path: '/portfolio' },
        { label: 'CAREER', path: '/career' },
        { label: 'CONTACT US', path: '/contact' },
    ];

    const handleMenu = () => setShow(!show);

    return (
        <Grid className={styles.responsiveHeader}>
            <Grid className={styles.header}>
                <img src={logo} alt="Logo" onClick={() => navigation('/')} />

                {/* Desktop Menu */}
                {!isTabletOrMobile && (
                    <List className={styles.desktopMenu}>
                        {data.map((item, idx) => (
                            <ListItemButton key={idx} onClick={() => navigation(item.path)}>
                                <ListItemText>{item.label}</ListItemText>
                            </ListItemButton>
                        ))}
                    </List>
                )}

                {/* Tablet/Mobile Hamburger */}
                {isTabletOrMobile && (
                    <ReorderThreeSharpIcon
                        fontSize={35}
                        style={{ cursor: 'pointer' }}
                        onClick={handleMenu}
                    />
                )}
            </Grid>

            {/* Tablet/Mobile Dropdown */}
            {isTabletOrMobile && show && (
                <List className={styles.menus}>
                    {data.map((item, idx) => (
                        <ListItemButton
                            key={idx}
                            onClick={() => {
                                navigation(item.path);
                                setShow(false);
                            }}
                        >
                            <ListItemText>{item.label}</ListItemText>
                        </ListItemButton>
                    ))}
                </List>
            )}
        </Grid>
    );
};

export default ResponsiveHeader;
